import React from "react";
import { DatePicker, Flex, Text } from "@jsq/ds/core";
import { SPACING } from "~/styles/variables";
import { useBillingDate } from "../contexts/BillingDateContext";
import { billingAsOfDatePicker } from "./styles_vanilla.css";

const AsOfDateSelector: React.FC = () => {
  const { asOfDate, setAsOfDate, maxAsOfDate } = useBillingDate();

  return (
    <Flex alignItems="center" gap={SPACING.SMALL}>
      <Text>As of date:</Text>
      <DatePicker
        selected={asOfDate}
        onChange={(date: Date | null) => date && setAsOfDate(date)}
        dateFormat="MM/dd/yyyy"
        hasIcon
        maxDate={maxAsOfDate}
        className={billingAsOfDatePicker}
        popperPlacement="bottom-end"
      />
    </Flex>
  );
};

export default AsOfDateSelector;
